exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.event-info-text[data-v-31ef5ddb] {\n    overflow: visible;\n    white-space: pre-line;\n}\n.notification-header[data-v-31ef5ddb] {\n    font-size: 26px;\n}\n.attendee-wrapper[data-v-31ef5ddb], .activity-wrapper[data-v-31ef5ddb] {\n    font-size: 0.8em;\n    color: #999;\n}\n", ""]);

// exports
